import { AxiosInstance } from "axios";
import { User } from "../types/User";

export default class UserService {
  private _endpoint = "User";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async search(searchTerm: string): Promise<User[]> {
    return this._client
      .get<any>(`${this._endpoint}/search/${searchTerm}`)
      .then((response) => {
        return response.data;
      });
  }

  public async get(id: string): Promise<User> {
    return this._client.get<any>(`${this._endpoint}/${id}`).then((response) => {
      return response.data;
    });
  }
}
